'use strict';

const get = require('lodash/get');

module.exports = (function() {
  class OffersMapCategoryFilters {
    static initClass() {
      this.prototype.onChangeCallbacks = [];
      this.prototype.rootUrl = '/merchant-page/offers-map';
      this.prototype.templates = {
        main: require('../main.html.mustache'),
      };
    }

    constructor({ el }) {
      this.triggerChange = this.triggerChange.bind(this);
      this.$el = $(el);
      this.fetchCategories((err, categories) => {
        if (err) {
          return;
        }

        this.categories = categories;
        this.render();
        this.$categories = this.$el.find('.categories');
        return void this.bindings();
      });
    }

    render() {
      const data = {
        categories: this.categories,
      };

      data.translate = data.t = () => str => I18n.t(str);

      return this.$el.html(this.templates.main.render(data));
    }

    bindings() {
      return this.$categories.find('.category').click(evt => {
        const oldValue = this.value();
        const $category = $(evt.currentTarget);

        if ($category.hasClass('active')) {
          // If the user clicks on the category that was already selected, we remove the selection.
          $category.removeClass('active');
        } else {
          this.$categories.find('.category.active').removeClass('active');
          $category.addClass('active');
        }

        if (oldValue !== this.value()) {
          return this.triggerChange();
        }
        return null;
      });
    }

    fetchCategories(cb) {
      $.ajax({
        url: `${this.rootUrl}/categories`,
        type: 'GET',
        contentType: 'application/json',
        dataType: 'json',
        success: res => {
          if ((res != null ? res.result : undefined) !== 'ok') {
            cb(new Error(get(res, 'error.code', undefined)));
            return;
          }

          cb(null, res.data.categories);
        },

        error() {
          cb(new Error('Request Failed'));
        },
      });
    }

    triggerChange() {
      return this.onChangeCallbacks.map(cb => {
        cb();
      });
    }

    onChange(cb) {
      this.onChangeCallbacks.push(cb);
    }

    value() {
      return this.$categories.find('.category.active').data('id');
    }

    clear() {
      const $active = this.$categories.find('.category.active');
      const shouldTriggerChange = $active.length > 0;
      $active.removeClass('active');

      if (shouldTriggerChange) {
        return this.triggerChange();
      }
      return null;
    }
  }
  OffersMapCategoryFilters.initClass();
  return OffersMapCategoryFilters;
})();
